import { createUseStyles } from 'react-jss'

/*
Convert pixel values to rem.
Parameters:
  - px (number)(Required): the value to convert in pixel.
  - base (number)(Optional): the base font size. Default: 14px.
*/
const rem = (px: number, base = 16): string =>
  `${Number((px / base).toFixed(4))}rem`

const useStyles = createUseStyles({
  tipBox: {
    position: 'relative',
    fontSize: '0.9rem',
    padding: '.5rem .6rem .5rem 2.3rem',
    border: `.0631rem solid #dcdcdc`,
    borderRadius: rem(5),
    backgroundColor: '#eaeaea',
    marginTop: '1rem',
  },

  tipBoxIcon: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1rem',
    margin: '0 .3rem 0 0',
    width: '1.5rem',
    borderRadius: [rem(5), 0, 0, 0],
    backgroundColor: '#dcdcdc',
  },
})

export default useStyles
